import type { Card } from '../../types';

/** Two high dice for a heavy single hit. */
export const EXECUTIONER: Card = {
  id: 'executioner',
  name: 'Executioner',
  type: 'attack',
  rarity: 'epic',
  size: { w: 2, h: 1 },
  cost: [
    { kind: 'min', value: 6 },
    { kind: 'min', value: 6 },
  ],
  effects: [{ kind: 'damage', amount: 14 }],
};
